import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const uploadImage = (id, path, data, sucess, stateChanged, failed) => {
    const storage = getStorage();
    console.log('3333333333333', storage)
    const storageRef = ref(storage, path + "/" + id + ".image");
    const uploadTask = uploadBytesResumable(storageRef, data);

    uploadTask.on('state_changed', 
        (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
            case 'paused':
                console.log('Upload is paused');
                break;
            case 'running':
                console.log('Upload is running');
                break;
            default:
                break;
            }
            stateChanged(snapshot.state, progress);
        }, 
        (error) => {
            failed(error)
        }, 
        () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            getDownloadURL(uploadTask.snapshot.ref)
            .then((downloadURL) => {
                sucess(downloadURL);
            }).catch(function(error) {
                console.log('firebase retreive download url failed', error);
                failed(error) ;
            });
        }
    );
}

export const uploadFileToStorage = (id, path, data, sucess, stateChanged, failed) => {
    const storage = getStorage();
    const storageRef = ref(storage, path + "/" + id + ".attach");
    const uploadTask = uploadBytesResumable(storageRef, data);

    uploadTask.on('state_changed', 
        (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
            case 'paused':
                console.log('Upload is paused');
                break;
            case 'running':
                console.log('Upload is running');
                break;
            default:
                break;
            }
            stateChanged(progress);
        }, 
        (error) => {
            failed(error)
        }, 
        () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            getDownloadURL(uploadTask.snapshot.ref)
            .then((downloadURL) => {
                sucess(downloadURL);
            }).catch(function(error) {
                console.log('firebase retreive download url failed', error);
                failed(error) ;
            });
        }
        );
}
